import { useEffect, useState, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";

const MIN_DISPLAY_MS = 1400;
const AUTO_DISMISS_MS = 7000;

const IntroOverlay = () => {
  const [show, setShow] = useState(
    () => typeof window !== "undefined" && !sessionStorage.getItem("introSeen")
  );

  const dismiss = useCallback(() => {
    sessionStorage.setItem("introSeen", "1");
    setShow(false);
  }, []);

  useEffect(() => {
    if (!show) return;
    document.body.style.overflow = "hidden";
    const events = ["mousemove", "wheel", "touchstart", "click", "keydown"];
    let attachTimer, autoTimer;
    attachTimer = setTimeout(() => {
      events.forEach((e) => window.addEventListener(e, dismiss, { once: true, passive: true }));
      autoTimer = setTimeout(dismiss, AUTO_DISMISS_MS);
    }, MIN_DISPLAY_MS);
    return () => {
      document.body.style.overflow = "";
      clearTimeout(attachTimer);
      clearTimeout(autoTimer);
      events.forEach((e) => window.removeEventListener(e, dismiss));
    };
  }, [show, dismiss]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="intro-overlay"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-cream"
        >
          <motion.div
            initial={{ opacity: 0, y: 90, scale: 0.85 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ type: "spring", stiffness: 160, damping: 9, mass: 1.1 }}
          >
            <motion.img
              src="/chantiers/logo-full.png"
              alt="Alexis Peintures — la vie en couleurs"
              animate={{ y: [0, -12, 0] }}
              transition={{ repeat: Infinity, duration: 2.4, ease: "easeInOut", delay: 1 }}
              className="w-64 md:w-96"
            />
          </motion.div>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.2, duration: 0.8 }}
            className="mt-10 text-xs uppercase tracking-[0.35em] text-taupe"
          >
            Bougez la souris pour entrer
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default IntroOverlay;
